import { render, staticRenderFns } from "./inputsTableform.vue?vue&type=template&id=3c42174e&"
import script from "./inputsTableform.vue?vue&type=script&lang=js&"
export * from "./inputsTableform.vue?vue&type=script&lang=js&"
import style0 from "./inputsTableform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports